import { render, staticRenderFns } from "./MattReI_Section_List.vue?vue&type=template&id=41192324"
import script from "./MattReI_Section_List.vue?vue&type=script&lang=js"
export * from "./MattReI_Section_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports